import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { LanguageProvider } from "@/context/LanguageContext";
import { Header, Footer } from "@/components/Layout";
import Home from "@/pages/Home";
import SearchPage from "@/pages/SearchPage";
import TripDetail from "@/pages/TripDetail";
import PublishTrip from "@/pages/PublishTrip";
import SendParcel from "@/pages/SendParcel";
import ParcelDetail from "@/pages/ParcelDetail";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsConditions from "@/pages/TermsConditions";
import Faq from "@/pages/Faq";
import HelpSupport from "@/pages/HelpSupport";
import AdminPanel from "@/pages/AdminPanel";
import Dashboard from "@/pages/Dashboard";
import ChatPage from "@/pages/ChatPage";
import UserProfile from "@/pages/UserProfile";
import NotFound from "@/pages/NotFound";

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) return <div className="max-w-7xl mx-auto px-6 py-16 text-slate-500">…</div>;
  if (!user) return <Navigate to={`/entrar?next=${encodeURIComponent(location.pathname)}`} replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <AuthProvider>
          <BrowserRouter>
            <Header />
            <main>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/pesquisa" element={<SearchPage />} />
                <Route path="/viagem/:id" element={<TripDetail />} />
                <Route path="/encomenda/:id" element={<ParcelDetail />} />
                <Route path="/utilizador/:id" element={<UserProfile />} />
                <Route path="/entrar" element={<Login />} />
                <Route path="/registar" element={<Register />} />
                <Route path="/recuperar-palavra-passe" element={<ForgotPassword />} />
                <Route path="/redefinir-palavra-passe" element={<ResetPassword />} />
                <Route path="/privacidade" element={<PrivacyPolicy />} />
                <Route path="/termos" element={<TermsConditions />} />
                <Route path="/faq" element={<Faq />} />
                <Route path="/ajuda" element={<ProtectedRoute><HelpSupport /></ProtectedRoute>} />
                <Route path="/admin" element={<ProtectedRoute><AdminPanel /></ProtectedRoute>} />
                <Route path="/publicar-viagem" element={<ProtectedRoute><PublishTrip /></ProtectedRoute>} />
                <Route path="/enviar-encomenda" element={<ProtectedRoute><SendParcel /></ProtectedRoute>} />
                <Route path="/painel" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
                <Route path="/mensagens" element={<ProtectedRoute><ChatPage /></ProtectedRoute>} />
                <Route path="/mensagens/:id" element={<ProtectedRoute><ChatPage /></ProtectedRoute>} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </main>
            <Footer />
            <Toaster position="top-center" richColors />
          </BrowserRouter>
        </AuthProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
